// signIn - what the sign-in pages say about a single sign-on that came back,
// and where a sign-in may send the person afterwards.

const SSO_ERRORS: Readonly<Record<string, string>> = {
  flow_expired: 'Your sign-in timed out. Try again.',
  idp_refused: 'Your identity provider did not sign you in.',
  no_subject: 'Your identity provider did not identify you.',
  email_untrusted: 'Your identity provider did not confirm your email address.',
  domain_not_allowed: 'Your email domain is not allowed for this organization.',
  account_conflict: 'This email belongs to an account your organization does not manage. Ask your administrator.',
  no_role: 'You have no access to this organization. Ask your administrator.',
  not_provisioned: 'Your account is not set up for this organization yet. Ask your administrator.',
  account_disabled: 'This account is disabled.',
  sso_unavailable: 'Single sign-on is not set up for this organization.',
};

/** The sentence for the `error` code a single sign-on came back with. */
export function ssoErrorMessage(code: string): string {
  return Object.hasOwn(SSO_ERRORS, code) ? SSO_ERRORS[code] : 'Sign-in failed. Try again.';
}

/** Where a sign-in goes when it was given nowhere, or somewhere off this site. */
export const DEFAULT_RETURN = '/dashboard';

/**
 * The path a sign-in may go to: one on this site, or the dashboard. The same
 * rule as the orchestrator's sso.SafeReturn, since both read a `return` the
 * address bar carried.
 */
export function safeReturn(raw: string | null | undefined): string {
  if (!raw?.startsWith('/') || raw.startsWith('//') || raw.startsWith('/\\')) return DEFAULT_RETURN;
  if (/[\r\n\t]/.test(raw)) return DEFAULT_RETURN;
  return raw;
}
